module.exports = __webpack_public_path__ + "static/media/ResumeRusyaidi.acc56aa2.pdf";